import { Injectable } from '@angular/core';

@Injectable()
export class ProviderDomain {
    constructor() { }

    destroy(): void {

    }
}
